import React, { useState, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaqsBlock } from '../faqsBlock/faqsBlock';
import { useResponsiveConfig } from '../../../hooks/responsiveConfigSwap';
import { BrandContext } from '../../../contextProviders/brandContext';
import { useGetFaqContentQuery } from '../../../data/kontentAi';
import { FAQ_CODENAME } from '../../../constants/cmsCodeName';
import { FeatureFlagContext } from '../../../contextProviders/featureFlagContext';
import { HelpTopicsSearch } from '../helpTopicsSearch/helpTopicsSearch';
import { createAlias } from '../../../utils/alias';
import { ContactUsDetails } from '../../contactUsDetails/contactUsDetails';
import { CONTACT_US_MESSAGE } from '../../../constants/constants';

export const HelpCenterNav = () => {
  const { activeBrandContext } = useContext(BrandContext);
  const { cspConfiguration } = useContext(FeatureFlagContext);
  const isKontentAiPreviewEnabled = cspConfiguration?.IsKontentAIPreviewEnabled || false;
  const {
    data: faqsData,
    isLoading: loading,
    error
  } = useGetFaqContentQuery({
    brandPartner: activeBrandContext.brand.key,
    faqCodeName: FAQ_CODENAME.HELP_CENTRE,
    previewEnabled: isKontentAiPreviewEnabled
  });

  const [activeTab, setActiveTab] = useState(undefined);
  const { search, pathname } = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(search);
  const category = params.get('category');
  const question = params.get('question');

  const navLayout = useResponsiveConfig({
    configDefinition: {
      default: {},
      1100: { layout: 'vertical' },
      720: {}
    }
  });

  const topicLayout = useResponsiveConfig({
    configDefinition: {
      default: { className: 'helpCentreTopic' },
      1100: { className: 'helpCentreTopic horizontal' },
      720: { className: 'helpCentreTopic vertical' }
    }
  });

  // TODO: Implement loading and error states
  if (loading) return <div>Loading FAQs...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!faqsData || Object.keys(faqsData).length === 0) return <div>No FAQs available.</div>;

  const tabs = Object.keys(faqsData);
  const currentTab = category ? tabs.find((tab) => createAlias(tab) === category) : activeTab || tabs[0];

  const handleTabClick = (tab) => {
    navigate(pathname);
    setActiveTab(tab);
  };

  return (
    <div
      className="helpCentreTopic"
      {...topicLayout}
    >
      <h1 className="mainPageHeader">Help centre</h1>
      <HelpTopicsSearch faqsData={faqsData} />

      <nav
        className={`topicsNavigatorBar ${navLayout.layout || 'horizontal'}Layout`}
        aria-label="Help topics navigation"
      >
        <ul>
          {tabs?.map((tab) => (
            <li key={tab}>
              <button
                type="button"
                className={`tab ${currentTab === tab ? 'activeTab' : ''}`}
                onClick={() => handleTabClick(tab)}
              >
                {faqsData[tab]?.title}
              </button>
            </li>
          ))}
        </ul>
      </nav>
      <main aria-label="Help Center Content">
        <section className="helpCentreTopicSubsection">
          <FaqsBlock
            heading={{ text: faqsData[currentTab]?.title }}
            questionSet={faqsData[currentTab]?.questions}
            redirectToQuestion={question}
          />
        </section>
        <section>
          <ContactUsDetails
            message={CONTACT_US_MESSAGE.FAQ}
            showIcon={false}
          />
        </section>
      </main>
    </div>
  );
};

export default HelpCenterNav;
